import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent, HeaderLogoComponent } from '@mwe/ui/components';
import { FooterComponent } from '../../layout/footer/footer.component';
import { MaintenanceService } from '../../service/maintenance/maintenance.service';
import { Maintenance } from '../../model/maintenance-http.model';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'ikp-maintenance',
  imports: [TranslatePipe, ButtonComponent, HeaderLogoComponent, FooterComponent],
  templateUrl: './ikp-maintenance.component.html',
  styleUrl: './ikp-maintenance.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IkpMaintenance implements OnInit {
  maintenanceService = inject(MaintenanceService);
  headline = 'maintenance.headline';
  subheadline = 'maintenance.subheadline';
  text = 'maintenance.text';
  // These properties are currently unused but can be enabled for future maintenance periods if needed.
  isBtnVisible = false;
  buttonLabelkey: string;
  isHeaderLogoVisible = false;

  async ngOnInit(): Promise<void> {
    const maintenanceModeResponse: Maintenance = await lastValueFrom(this.maintenanceService.fetchMaintenanceMode()).catch(
      () => ({ enabled: false }) as Maintenance,
    );
    const isMaintenanceModeEnabled: boolean = maintenanceModeResponse.enabled;
    if (!isMaintenanceModeEnabled) {
      window.location.href = window.location.origin;
    }
  }

  onbuttonClick(): void {
    //placeholder for button logic
  }
}
